// Get modal element
const modal = document.querySelector('.modal');
// Get open modal button
const modalBtn = document.querySelector('.modal--btn')
// Get close btn
const closeBtn = document.querySelector('.btn--close')


// listen for open click
modalBtn.addEventListener('click', openModal)

// listen for close click
closeBtn.addEventListener('click', closeModal)

// listne for outsideClick
window.addEventListener('click', outsideClick)

//open modal
function openModal() {
    modal.style.display = 'block';
    modal.style.opacity = '1' ;
    modalBtn.style.display = 'none'
}
// close modal
function closeModal() {
    modal.style.display = 'none';
    modal.style.opacity = '0' ;
    modalBtn.style.display = 'block'
}
//close on outside click
function outsideClick(e) {
if (e.target == modal){
modal.style.display = 'none';
modalBtn.style.display = 'block'
}
}
